"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.manhattanLength = void 0;
/**
 * Returns the Manhattan length of the given 2-vector.
 * @param p a vector
 */
function manhattanLength(p) {
    return Math.abs(p[0]) + Math.abs(p[1]);
}
exports.manhattanLength = manhattanLength;
//# sourceMappingURL=manhattan-length.js.map